/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum OralSupplementsViewerAliases {
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  ORAL_SUPPLEMENTS_CONTENT_PANEL = 'oral-supplements-content-panel',
  ORAL_SUPPLEMENTS_DETAILS_CARD = 'oral-supplements-details-card',
  ORAL_SUPPLEMENTS_EXECUTE_BUTTON = 'oral-supplements-execute-button',
  ORAL_SUPPLEMENTS_GLOBAL_ACTIONS = 'oral-supplements-global-actions',
  ORAL_SUPPLEMENTS_PANEL_BUTTON = 'oral-supplements-panel-button',
  ORAL_SUPPLEMENTS_VIEWER_CONTEXTUAL_BAR = 'oral-supplements-viewer-contextual-bar',
  ORAL_SUPPLEMENTS_VIEWER_DECK = 'oral-supplements-viewer-deck',
  ORAL_SUPPLEMENTS_VIEWER_LAYOUT = 'oral-supplements-viewer-layout',
  PANEL_HEADER = 'panel-header',
  RESCHEDULE_ORAL_SUPPLEMENTS_ACTION = 'reschedule-oral-supplements-action',
  SUSPEND_ORAL_SUPPLEMENTS_ACTION = 'suspend-oral-supplements-action',
}
export { OralSupplementsViewerAliases };
